import React from "react";
import { AuthShell } from "@/components/AuthShell";
const extractErrorMessage = (payload: unknown, fallback: string): string => {
  if (typeof payload === "string" && payload.trim()) return payload;
  if (Array.isArray(payload)) {
    const first = payload.find((item) => typeof item === "string" && item.trim()) as string | undefined;
    if (first) return first;
  }
  if (payload && typeof payload === "object") {
    const obj = payload as Record<string, unknown>;
    for (const key of ["detail", "message", "error", "reason"]) {
      const value = obj[key];
      if (typeof value === "string" && value.trim()) return value;
    }
    const nested = obj.detail;
    if (nested && typeof nested === "object") {
      const nestedObj = nested as Record<string, unknown>;
      for (const key of ["detail", "message", "error", "reason"]) {
        const value = nestedObj[key];
        if (typeof value === "string" && value.trim()) return value;
      }
    }
    try {
      const compact = JSON.stringify(obj);
      if (compact && compact !== "{}") return compact;
    } catch {
      // ignore stringify failure and fall back below
    }
  }
  return fallback;
};

const LoginPage: React.FC = () => {
  const [error, setError] = React.useState("");
  const startedRef = React.useRef(false);

  React.useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    const redirectToCognito = async () => {
      setError("");
      try {
        const res = await fetch("/api/v1/auth/oidc/login-url");
        const body = await res.json();
        if (!res.ok || !body.authorization_url) throw new Error(extractErrorMessage(body, "SSO login init failed"));
        window.location.href = String(body.authorization_url);
      } catch (err) {
        setError(err instanceof Error ? err.message : "SSO login init failed");
      }
    };

    void redirectToCognito();
  }, []);

  return <AuthShell title="SprintBid Access" message="Redirecting to Cognito..." error={error || undefined} />;
};

export default LoginPage;

